import React from 'react';

const RemindersPage = ():React.ReactElement => {
	return (
		<div>
			<h2>This is the reminders page.</h2>
		</div>
	);
};

export default RemindersPage;